import React, {Component} from 'react'
import { Link } from "react-router-dom";

import CompaniesTable from '../CompaniesTable'
import Pagination from '../Pagination'
import {Card, CardBody, Button} from 'reactstrap';
import { Trans } from "react-i18next";
import Switch from "react-switch";

class Companies extends Component{
  
  componentDidMount(){
	  const {companies, getCompanies} = this.props
	  
	  this.props.getCompanies({values: companies != null && companies.params != null ? companies.params :  {cumulative: true}})
  }

  render(){
	  const {companies, selected_companies, getCompanies, selectCompnaies} = this.props
	  
	  return (	    
		        <Card>
		          <CardBody>
			          {companies != null &&
			           <Pagination total_pages={companies.total_pages} current_page={companies.current_page}  page_action={(params) => getCompanies({values: {...companies.params, ...params}})} >
			             <div style={{alignItems: 'center', display: 'flex'}}>
				             Visualizzazione cumulativa 
				             &nbsp; <Switch onChange={() => getCompanies({values: {...companies.params,  cumulative: !companies.params.cumulative}})}
						                        checked={companies.params.cumulative}
						                        onColor="#86d3ff"
						                        onHandleColor="#2693e6"
						                        handleDiameter={30}
						                        uncheckedIcon={false}
						                        checkedIcon={false}
						                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
						                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
						                        height={20}
						                        width={48}
				             />

			             </div>
			             
			             {selected_companies.length > 0 &&
			              
			              <React.Fragment>
				              Hai selezionato <b>{selected_companies.length}</b> società su <b>{companies.companies_ids.length}</b><br/>
				              <form action="/api/companies/filter.xlsx" method="post" target="_new" style={{display: 'inline-block'}}>
				                <input type="hidden" value={selected_companies.map(ic => ic.id )} name="selected_companies" />
				                
				                <button type="submit" className="btn btn-primary"> <i className="fas fa-file-pdf"></i> <Trans>companies.actions.download_xls</Trans></button>
				                
				              </form>
			             &nbsp;
			             <Link to={'/analysis'} className="btn btn-primary" >
				             <i className="fas fa-chart-line"></i> <Trans>companies.actions.analysis</Trans>
			             </Link>
			              </React.Fragment>
			             }
			             
			             
			             <CompaniesTable companies={companies.list} getCompanies={getCompanies} filters={companies.params} companies_ids={companies.companies_ids} include_more={true} selected_companies={selected_companies} selectCompnaies={selectCompnaies} issuing_companies={companies.issuing_companies} />
			           </Pagination>
			          }
		          </CardBody>
		        </Card>
	  )
  }
}
export default Companies
